import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../index';

export interface LoaderState {
  isLoading: boolean;
}

const initialState: LoaderState = {
  isLoading: false,
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoad: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setLoad } = loaderSlice.actions;

export const selectIsLoading = (state: RootState) => state.loader.isLoading;

export default loaderSlice.reducer;
